import { actionTypes } from '../actionTypes';

export const navigateToMenuItem = (menuProperties) => {
	const { headerSectionLabel, headerTextIdentifier, menuIdentifier, menuItems } = menuProperties.menu;

	return {
		type: actionTypes.navigation.admin.clicked,
		payload: {
			headerSectionLabel,
			headerTextIdentifier,
			menuItems,
			menuIdentifier
		}
	};
};
